import React from 'react';
import { useTranslation } from 'react-i18next';
import './Loader.css';

function Loader() {
  const { t } = useTranslation();
  return (
    <div className="modal_popup_wrap confirm_wrap" style={{ background: 'transparent', boxShadow: 'none' }}>
      <div className="modal_popup_box confirm_box">
        <div className="modal_popup confirm" style={{ background: 'transparent' }}>
          <div className="loader">
            <div className="loader_content">{t('modal.message.loading_ellipsis')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loader;
